import {Component} from '@angular/core';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';

@Component({
    selector: 'app-html-preview-step7',
    templateUrl: './html-preview-step7.component.html',
    styleUrls: ['./html-preview-step7.component.scss']
})

export class HtmlPreviewStep7Component {

    public lavId: number = 0;
    public lavNome: string = '';
    public lavSerramentista: string= '';
    private baseUrl: string = environment.baseUrl;
    public htmlText: string;
    public downIsDisable: boolean = true;

    constructor(private http: HttpClient, private config: DynamicDialogConfig) {
        this.lavId = this.config.data.id;
        this.lavNome = this.config.data.nome;
        this.lavSerramentista = this.config.data.serramentista;
        this.getHtml().subscribe(
            data => {
                if (this.isJson(data)) {
                    let jp = JSON.parse(data);
                    this.htmlText = jp.message;
                } else {
                    this.downIsDisable = false;
                    this.htmlText = data
                }
            }
        )
    }

    private isJson(json: string): boolean {
        try {
            JSON.parse(json);
        } catch (e) {
            return false;
        }
        return true;
    }

    getHtml(): Observable<any> {
        // let url = this.baseUrl + '/docx/doc3step7_html/' + this.lavNome;
        let url = this.baseUrl + '/docx/doc3step7_html/' + this.lavId ;
        return this.http.get(url, {responseType: 'text'});
    }

    downloaDocumento(): void {
        // this.modalDown = false;
        window.location.href = this.baseUrl + '/docx/doc3step7_pdf/' + this.lavNome + '/' + this.lavSerramentista;
        // window.location.href = this.baseUrl + '/docx/doc3step7_pdf/' + this.lavId;
    }

}
